<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import type {ButtonStyle, ButtonType, ComponentSize} from 'shared/ui-widgets/types';
    import type {ActionArray} from 'shared/utils/svelte-actions-utils';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';
    import {exists} from 'shared/utils/custom-utils';
    import {useActions} from 'shared/utils/svelte-actions-utils';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let icon: UIcons;
    export let buttonType: ButtonType = 'button';
    export let buttonSize: ComponentSize = 'sm';
    export let buttonStyle: ButtonStyle = 'default';
    export let title: string | null = null;
    export let additionalClasses = '';
    export let tooltipLabel: string | null = null;
    export let disabled = false;
    export let href: string | null = null;
    export let anchorTarget: '_self' | '_blank' = '_blank';
    export let use: ActionArray = [];

    const buttonSizes = {
        'xs': {
            size: 22,
            iconSize: 12
        },
        'sm': {
            size: 30,
            iconSize: 13
        },
        'md': {
            size: 34,
            iconSize: 15
        },
        'lg': {
            size: 42,
            iconSize: 17
        }
    };
</script>

<svelte:element this={exists(href) ? 'a' : 'button'}
                target={anchorTarget}
                role="button"
                tabindex="0"
                class="kp-icon-button {additionalClasses} btn-{buttonStyle}"
                use:tooltip={{content: tooltipLabel ?? '', role: 'tooltip', enabled: exists(tooltipLabel)}}
                use:useActions={use}
                on:click|stopPropagation
                type={buttonType}
                title={title}
                disabled={disabled}
                style:--size="{buttonSizes[buttonSize].size}px"
                style:--icon-size="{buttonSizes[buttonSize].iconSize}px"
                {href}
                {...$$restProps}>

    <UIcon {icon}/>
</svelte:element>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    a {
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }

    .kp-icon-button {
        width: var(--size);
        height: var(--size);
        font-size: var(--icon-size);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: @border-radius-default;
        outline: none;
        cursor: pointer;
        transition: opacity 0.3s ease-in-out, background-color 0.3s ease-in-out;

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }
</style>